import axios from "axios";
import qs from "qs";
import store from "@/store";
import router from "@/router";

let win = window;

const request = ({ method = "post", url, data = {}, headers }) => {
    let options = {
        withCredentials: true,
        headers: Object.assign({}, headers, {
            "Content-Type": "application/x-www-form-urlencoded",
            "player-token": store.state.params.player_token
        }),
        method,
        url
    };

    data.lang = store.state.params.language;

    if (method === "get") {
        options.params = data;
    } else if (method === "put") {
        options.headers["Content-Type"] = "application/json";
        options.data = data;
    } else if (data instanceof FormData) {
        options.data = data;
    } else {
        options.data = qs.stringify(data);
    }

    return axios(options)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            let res = err.response.data;
            if (res && res.code === 102) {
                store.commit("COMMIT_WEB_VIEW", {
                    method: "getPlayerToken",
                    callback: win.setPlayerToken
                });
            }
            if (res && res.code === 101) {
                let to =
                    store.state.pageParent === "security" ? "security" : "lost";
                router.push({
                    name: to,
                    query: Object.assign({}, store.state.params, {
                        t: Date.now()
                    })
                });
            }
            throw res;
        });
};

export default request;
